<div fxFlex="row" fxFlex>
    <div fxFlex="240px" class="sidenavigationTop hidexs">
        <div class="iwg-service-name">{{selectedServiceName}}</div>
        <div class="sidenavigationInner">
            <div>
                <button mat-button class="sidenavigationassbtn active-side-nav" layout
                        [routerLink]="['/quotes']" [queryParams] = "{
            service: state.service}">Quotes
                    <span class="activeiconcolor"></span>
                </button>
            </div>
            <div>
                <button mat-button class="sidenavigationassbtn" layout
                        [routerLink]="['/assignments']" [queryParams] = "{ service: state.service }">
                    {{labelPlural}}<span flex></span>
                    <span flex></span>
                </button>
            </div>
            <app-buttonbar></app-buttonbar>
        </div>
    </div>

    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span>Services</span> » <span>{{selectedServiceName}}</span> » <span
                    class="iwg-page-header-small-title">Quotes</span>
            </div>

          
            <div layout="column" flex>
                <div class="iwg-summary" layout="row" layout-xs="column" *ngIf="summary">
                    <div flex *ngFor="let item of summary" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName
                        && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
                        <div class="iwg-value">{{item.Value}}</div>
                        <div class="iwg-label">{{item.Name}}</div>
                    </div>
                </div>
                <div>
                    <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
                                   (selectedTabChange)="onTabChanged($event);">
                        <mat-tab *ngFor="let scope of globalScopes" label="{{scope.name}}">
                            <ng-container *ngTemplateOutlet="tabContent"></ng-container>
                        </mat-tab>
                    </mat-tab-group>

                    <ng-template #tabContent>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayout.lt-sm="column"
                             fxLayoutAlign.lt-sm="start" class="iwg-grid-filters mat-padding mlt-1 mlr-15" filterSection>

                            <div>
                <span style="font-size: 15px;" class="mobileactive">
                  <span flex fxFlex="48" fxLayoutAlign="space-between center" style="font-size: 15px;">
                    Quotes Active From:</span>
                  <mat-datepicker-toggle flex fxFlex="11" fxLayoutAlign="space-between center" matSuffix [for]="start">
                  </mat-datepicker-toggle>
                  <mat-form-field appearance="none" color="accent" flex fxFlex="35">
                    <input matInput [matDatepicker]="start" [(ngModel)]="state.start"
                        [max]="state.end" (dateChange)="handleDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="start">
                      <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #start></mat-datepicker>
                  </mat-form-field>
                </span>
                            </div>
                            <div>
                <span class='ml-15 mobileactive'>
                  <span flex fxFlex="10" fxLayoutAlign="space-between center">To:</span>

                  <mat-datepicker-toggle flex fxFlex="20" fxLayoutAlign="space-between center" matSuffix [for]="end">
                  </mat-datepicker-toggle>
                  <mat-form-field appearance="none" color="accent" flex fxFlex="55">
                    <input matInput [matDatepicker]="end" [(ngModel)]="state.end"
                        [min] = "state.start" (dateChange)="handleDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="end">
                      <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #end></mat-datepicker>
                  </mat-form-field>
                </span>
                            </div>
                            <div fxFlex="20" *ngIf="(state.global_scope != 3)" class='ml-15'>
                <span class="ml-10">
                  <app-country-select *ngIf="(state.global_scope != 3)" [selectedItem]="state.country" [idOnly]="true"
                                      [alltext]="'All'" [helptext]="''" (countryChange)="handleCountryChange($event);">
                  </app-country-select>
                </span>
                            </div>
                           
                            <div fxFlex="20" class="assignemt-vista2" style="margin-top: 5px;">
                <span style="width: 100%;">
                  <mat-form-field flex>
                    <mat-label>Search</mat-label>
                    <input matInput [(ngModel)]="state.q" (input)="onSearchChange($event.target.value)">
                  </mat-form-field>
                </span>
                            </div>
                            <div fxFlex="3">
                <span class="ml-10 mobile-downloadbtn">
                  <button mat-icon-button aria-hidden="false" aria-label="Download" class="inputassignicon"
                          (click)="exporter.exportTable('csv', {fileName: 'quotes'})">
                    <mat-icon>file_download</mat-icon>
                  </button>
                </span>
                            </div>

                        </div>
                    </ng-template>
                </div>

                <!-- double scroll bar checking code -->
                <div class="wrapper1" #wrapper1>
                    <div class="div1" #div1></div>
                </div>
                <div class="wrapper2" #wrapper2>
                   
                    <div class="div2" #div2>
                        <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
                        <mat-table #listTable matTableExporter matSort [dataSource]="dataSource" #exporter="matTableExporter"
                                   [hiddenColumns]="hideColsInExport" (matSortChange)="sortData($event)" style="min-width: 100%;">

                            <!-- Id Column -->
                            <ng-container matColumnDef="QuoteID">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Reference ID</mat-header-cell>
                                <mat-cell *matCellDef="let quotes">
                                    <a matTooltip="{{quotes.Title}}" matTooltipPosition="below" [routerLink]="['/quotes', quotes.ID]"
                                       [queryParams]="{
                                  quoteId: quotes.ID,
                                service: state.service,
                                page: state.page,
                                limit: state.limit,
                                order_by: state.order_by,
                                order: state.order,
                                start: state.start,
                                end: state.end,
                                q: state.q,
                                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                global_scope: state.global_scope
                              }">{{quotes.QuoteID}}</a>
                                </mat-cell>
                            </ng-container>

                            <!-- Title Column -->
                            <ng-container matColumnDef="Title">
                                <mat-header-cell *matHeaderCellDef mat-sort-header>Quote</mat-header-cell>
                                <mat-cell *matCellDef="let quotes">
                                    <a matTooltip="{{quotes.Title}}" matTooltipPosition="below" [routerLink]="['/quotes', quotes.ID]"
                                       [queryParams]="{
                                  quoteId: quotes.ID,
                                service: state.service,
                                page: state.page,
                                limit: state.limit,
                                order_by: state.order_by,
                                order: state.order,
                                start: state.start,
                                end: state.end,
                                q: state.q,
                                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                global_scope: state.global_scope
                              }"> {{quotes.Title}}></a>
                                </mat-cell>
                            </ng-container>

                            <!-- EndClient Column -->
                            <ng-container matColumnDef="EndClient">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="tabledhead hidexs">End Client
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="tabledbody hidexs"> {{quotes.EndClientName}} </mat-cell>
                            </ng-container>

                            <!-- Job Title -->
                            <ng-container matColumnDef="JobTitle">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Job Title
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.JobTitle}} </mat-cell>
                            </ng-container>

                            <!-- Location Column -->
                            <ng-container matColumnDef="Location">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Country</mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.Country}} </mat-cell>
                            </ng-container>

                            <!-- Status Column -->
                            <ng-container matColumnDef="StatusName">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Status</mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.Status}} </mat-cell>
                            </ng-container>

                            <!-- Worker Column -->
                            <ng-container matColumnDef="WorkerCount">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Workers</mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.NumberOfWorkers}} </mat-cell>
                            </ng-container>


                            <!-- DateRequested Column -->
                            <ng-container matColumnDef="DateRequested">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Submitted
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.DateRequested | date}} </mat-cell>
                            </ng-container>

                            <!-- Expiration Column -->
                            <ng-container matColumnDef="Expiration">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Expiration
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{quotes.QuoteExpirationDate}} </mat-cell>
                            </ng-container>

                            <!-- Price Name Column -->
                            <ng-container matColumnDef="Price">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Price</mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs">
                                    {{quotes.EstimatedMonthlyInvoiceUSD | currency: '$' : 'symbol-narrow' : '1.2-2'}} {{quotes.EntityCurrencyCode}}
                                </mat-cell>
                            </ng-container>

                            <!-- ClientMarkup Column -->
                            <ng-container matColumnDef="ClientMarkup">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Markup (%)
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{(quotes.ClientMarkup/100) | percent : '1.2'}} </mat-cell>
                            </ng-container>

                            <!-- SalesTax Column -->
                            <ng-container matColumnDef="SalesTax">
                                <mat-header-cell *matHeaderCellDef mat-sort-header disableClear class="hidexs">Sales Tax (%)
                                </mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs"> {{(quotes.SalesTax/100) | percent : '1.2'}} </mat-cell>
                            </ng-container>

                            <!-- Operations Menu -->
                            <ng-container matColumnDef="OprMenu">
                                <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
                                <mat-cell *matCellDef="let quotes" class="hidexs">
                                    <button mat-icon-button [matMenuTriggerFor]="elementMenu" aria-label="Menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>

                                    <mat-menu #elementMenu="matMenu" class="submenu">
                                        <button mat-menu-item [routerLink]="['/quotes', quotes.ID]" [queryParams]="{
                                  quoteId: quotes.ID,
                                  service: state.service,
                                  page: state.page,
                                  limit: state.limit,
                                  order_by: state.order_by,
                                  order: state.order,
                                  start: state.start,
                                  end: state.end,
                                  q: state.q,
                                  country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                                  global_scope: state.global_scope
                                }">
                                            Show Details
                                        </button>

                                        <button mat-menu-item *ngIf="ShowEngageButton"
                                                (click)="showAssignmentDialog($event,quotes.PriceQuoteGUID)">
                                            Add
                                        </button>

                                        <button mat-menu-item *ngIf="quotes.StatusID == 1"
                                                (click)="showTransferAssignmentDialog($event,quotes.ID)">
                                            Edit
                                        </button>

                                        <button mat-menu-item *ngIf="quotes.StatusID == 1" (click)="delete(quotes.ID)">
                                            Delete
                                        </button>
                                    </mat-menu>

                                </mat-cell>
                            </ng-container>

                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                        </mat-table>

                    </div>
                </div>

                <mat-paginator [length]="totalRecords" [pageSize]="state.limit" class="myvista-paginator"
                               (page)="pageEvent = $event; naviatePageTo($event)" [pageSizeOptions]="[25, 100, 500, 1000, 10000]"
                               showFirstLastButtons>
                </mat-paginator>

            </div>
            <!-- Table Contents end-->

        </div>
        <div class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>
